import _c from "../CodeSkeleton/CodeSkeleton.module.css";
import React, {Fragment} from "react";

const ReactBottomShell = () => {
    return <Fragment>
        <span className={_c.indent1}><span className={_c.orange}>return</span><span className={_c.gold}>{" <GraphX "}</span><span className={_c.plain}>{"data={pieJson}"}</span><span className={_c.gold}>{"/>"}</span></span>
        <span>{"};"}</span>
        <span><span className={_c.orange}>export default </span><span className={_c.gold}>GraphXPage</span><span className={_c.orange}>;</span></span>
    </Fragment>
};

export default ReactBottomShell;